import { useEffect, useState } from 'react';
import { formatDistanceToNowStrict } from 'date-fns';

const REFRESH_INTERVAL_MS = 30_000;

type RelativeGeneratedTimeProps = {
  generatedDateTimeMs: number | null;
};

const formatRelativeTime = (generatedDateTimeMs: number | null) =>
  generatedDateTimeMs ? formatDistanceToNowStrict(generatedDateTimeMs) : '';

export const RelativeGeneratedTime = ({ generatedDateTimeMs }: RelativeGeneratedTimeProps) => {
  const [relativeGeneratedTime, setRelativeGeneratedTime] = useState(() => formatRelativeTime(generatedDateTimeMs));

  useEffect(() => {
    setRelativeGeneratedTime(formatRelativeTime(generatedDateTimeMs));

    if (!generatedDateTimeMs) return () => {};

    const interval = setInterval(
      () => setRelativeGeneratedTime(formatDistanceToNowStrict(generatedDateTimeMs)),
      REFRESH_INTERVAL_MS,
    );

    return () => clearInterval(interval);
  }, [generatedDateTimeMs]);

  return <span className="text-xs-sb text-base-20">{`Generated ${relativeGeneratedTime} ago`}</span>;
};
